import { defineStore } from 'pinia';

const useModalsStore = defineStore('modals', {
  state: () => ({
    continueModalMessage: '' as string,
    isContinueModalVisible: false as boolean,
    continueModalConfirmCounter: 0 as number,
    confirmationCustomMessage: '' as string,
    isConfirmationModalVisible: false as boolean,
    isConfirmationModalRejectButtonHidden: false as boolean,
    confirmationModalAnswerCounter: 0 as number,
    confirmationModalAnswerStatus: false as boolean,
  }),
  actions: {
    showContinueModal(message: string) {
      this.continueModalMessage = message;
      this.isContinueModalVisible = true;
    },
    hideContinueModal() {
      this.isContinueModalVisible = false;

      setTimeout(() => {
        this.continueModalMessage = '';
      }, 500);
    },
    incrementContinueModalConfirmCounter() {
      this.hideContinueModal();
      this.continueModalConfirmCounter++;
    },
    showConfirmationModal(message: string = '') {
      this.confirmationCustomMessage = message;
      this.isConfirmationModalVisible = true;
    },
    hideConfirmationModal() {
      this.isConfirmationModalVisible = false;

      setTimeout(() => {
        this.confirmationCustomMessage = '';
        this.isConfirmationModalRejectButtonHidden = false;
      }, 500);
    },
    incrementConfirmationModalAnswerCounter(status: boolean) {
      this.hideConfirmationModal();
      this.confirmationModalAnswerStatus = status;
      this.confirmationModalAnswerCounter++;
    },
    hideConfirmationModalRejectButton() {
      this.isConfirmationModalRejectButtonHidden = true;
    },
  },
});

export default useModalsStore;
